module.exports = __webpack_public_path__ + "static/media/Theme1.6e0ff40a.png";